import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";


interface PointOfContactCollectionOptions {
    installId: number
    organizationId: number
}


export class PointOfContactCollection extends CachingCollection<Backbone.Model> {

    installId: number;
    organizationId: number;

    constructor(initialModels: Object[] | any[], options: PointOfContactCollectionOptions) {
        super(initialModels, options);
        this.organizationId = options.organizationId;
        this.installId = options.installId;
    }

    url = () => {
        return window.location.origin + '/api/v1/organizations/' + this.organizationId + '/installs/' + this.installId + '/poc';
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/PointsOfContact.ts